import { render, staticRenderFns } from "./superBAnalyst.vue?vue&type=template&id=1281b509&"
import script from "./superBAnalyst.vue?vue&type=script&lang=js&"
export * from "./superBAnalyst.vue?vue&type=script&lang=js&"
import style0 from "./superBAnalyst.vue?vue&type=style&index=0&id=1281b509&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports